import { PAYMENT_PERMISSIONS } from './payments';

export const paymentPermissionTranslations = {
  [PAYMENT_PERMISSIONS.UNLIMITED_STREAMING]:
    'widget.payments.unlimitedStreaming',
  [PAYMENT_PERMISSIONS.INSTANT_ACCESS]: 'widget.payments.instant-access',
  [PAYMENT_PERMISSIONS.MONTHLY_PAYMENT]: 'widget.payments.monthly-payment',
  [PAYMENT_PERMISSIONS.SINGLE_VIDEO]: 'widget.payments.single-video',
  [PAYMENT_PERMISSIONS.ONE_PAYMENT]: 'widget.payments.one-payment',
  [PAYMENT_PERMISSIONS.SINGLE_VIDEO_STREAMING]:
    'widget.payments.single-video-streaming',
  [PAYMENT_PERMISSIONS.STREAMING_PERIOD]: 'widget.payments.streaming-period',
  [PAYMENT_PERMISSIONS.UNLIMITED_DOWNLOADS]:
    'widget.payments.unlimitedDownloads',
  [PAYMENT_PERMISSIONS.DOWNLOAD_ANY_TIME]: 'widget.payments.downloadAnytime',
};
